import { PATHS } from '@/routes/routes.types';
import { MenuItem } from './Sidebar.types';

export const Menu_Item: MenuItem[] = [
  {
    label: 'Dashboard',
    subItems: [
      { label: 'Tableau de bord', icon: 'pi pi-warehouse', to: '/' },
      { label: 'Finance', icon: 'pi pi-wallet', to: PATHS.FINANCE },
      {
        label: 'Utilisateurs',
        icon: 'pi pi-users',
        to: PATHS.USERS,
      },
      {
        label: 'Classes',
        icon: 'pi pi-building-columns',
        to: PATHS.CLASSES,
      },
    ],
  },
  {
    label: 'Contenu',
    subItems: [
      { label: 'Leçons', icon: 'pi pi-book', to: PATHS.LESSONS },
      { label: 'Epreuves', icon: 'pi pi-file', to: PATHS.TESTS },
      { label: 'Astuces', icon: 'pi pi-heart', to: PATHS.TIPS },
      { label: 'Disciplines', icon: 'pi pi-bookmark', to: PATHS.DISCIPLINES },
    ],
  },
  {
    label: 'Business',
    subItems: [
      { label: 'Entreprise', icon: 'pi pi-briefcase', to: PATHS.COMPANY },
      {
        label: 'Publicité',
        icon: 'pi pi-chart-line',
        to: PATHS.B2B_FINANCE,
      },
      {
        label: 'Offre',
        icon: 'pi pi-tag',
        to: PATHS.OFERS,
      },
    ],
  },
  {
    label: 'Configuration',
    subItems: [
      { label: 'Ecoles', icon: 'pi pi-building', to: PATHS.SCHOOLS },
      { label: 'Cadeau', icon: 'pi pi-gift', to: PATHS.GIFTS },
      { label: 'FAQ', icon: 'pi pi-question-circle', to: PATHS.FAQ },
      { label: 'Examen Blanc', icon: 'pi pi-file', to: PATHS.BLANK_EXAM },
      {
        label: 'Etablissements',
        icon: 'pi pi-building',
        to: PATHS.ESTABLISHMENTS,
      },
      {
        label: 'Intégrations Socium',
        icon: 'pi pi-sitemap',
        to: PATHS.SOCIUM,
      },
    ],
  },
];
